<div class="ui-g ui-fluid">
    <div class="ui-g-12" class="background">
        <div class="ui-g-12">
          <h2 class="title">Glosario de conceptos</h2>
        </div>
    </div>
    <div class="ui-g-12 ui-fluid p-grid">
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"  style="margin: 0; min-height: 360px;">
                    <img src="assets/images/glossary/Cobertura.png" alt="" >
                    <h3 class="subTitle">Coberturas:</h3>
                    <p class="ph"><em>(s.)</em> Son los compromisos que se definen y especifican en las
                        condiciones particulares y generales de las pólizas. Con las
                        coberturas el asegurado está protegido hasta el límite económico
                        pactado, de las consecuencias que provengan de un siniestro.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 360px;">
                    <img src="assets/images/glossary/deducible.png" alt="" >
                    <h3 class="subTitle">Deducible:</h3>
                    <p class="ph"><em>(s.)</em> Cantidad mínima de gastos que cada asegurado
                        debe pagar, para tener derecho a reembolso. En la
                        mayoría de pólizas de gastos médicos, éste se aplica una
                        vez al año. En el caso de pólizas de vehículos, éste se aplica
                        cada vez que ocurre un accidente o siniestro.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray" style="margin: 0; min-height: 360px;">
                    <img src="assets/images/glossary/copago.png" alt="" >
                    <h3 class="subTitle">Copago:</h3>
                    <p class="ph"><em>(s.)</em> Es un monto mínimo que usted como asegurado paga al
                        momento de utilizar un servicio médico, ya sea por consulta médica,
                        hospitalización, exámenes de laboratorio o medicamentos.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 360px;">
                    <img src="assets/images/glossary/maximo-anual.png" alt="" >
                    <h3 class="subTitle">Máximo anual de coaseguro:</h3>
                    <p class="ph"><em>(s.)</em> Es la cantidad máxima de desembolso que absorbe un
                        asegurado de acuerdo con las condiciones y montos
                        indicados en la póliza contratada, aplica año calendario y es un
                        distinto monto para gastos dentro fuera del Area
                        Centroamericana. Este beneficio aplica para cada uno de los
                        integrantes asegurados.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"   style="margin: 0; min-height: 305px;">
                    <img src="assets/images/glossary/beneficiario.png" alt="" >
                    <h3 class="subTitle">Beneficiario:</h3>
                    <p class="ph"><em>(s.)</em> Es quien recibe la indemnización
                        por un reclamo. Regularmente es el asegurado,
                        a excepción de un seguro de vida en el cual el beneficiario
                        es nombrado por el asegurado al contratar el seguro.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 305px;">
                    <img src="assets/images/glossary/exclusiones.png" alt="" >
                    <h3 class="subTitle">Exclusiones:</h3>
                    <p class="ph"><em>(s.)</em> Son todos aquellos casos o elementos que la
                        aseguradora no cubrirá en la póliza de seguros contratada.
                        Estas exclusiones se pueden dar va sea por enfermedades
                        preexistentes o por la misma cobertura del seguro contratado.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"  style="margin: 0; min-height: 305px;">
                    <img src="assets/images/glossary/prima.png" alt="" >
                    <h3 class="subTitle">Prima:</h3>
                    <p class="ph"><em>(s.)</em> Es el pago mensual o anual que el asegurado debe efectuar
                        a la aseguradora, para mantener su seguro vigente.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 305px;">
                    <img src="assets/images/glossary/Riesgo.png" alt="" >
                    <h3 class="subTitle">Riesgo:</h3>
                    <p class="ph"><em>(s.)</em>  Amenaza de pérdida o deterioro que afecta a bienes
                        determinados o a derechos específicos como la vida, la salud
                        o la integridad física e intelectual de un individuo.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"  style="margin: 0; min-height: 320px;">
                    <img src="assets/images/glossary/coaseguro.png" alt="" >
                    <h3 class="subTitle">Coaseguro:</h3>
                    <p class="ph">El coaseguro es representado por un porcentaje el
                        cual define cuánto deberá pagar del total de los
                        gastos cubiertos por el seguro después del deducible.
                        Por ser un porcentaje, entre mayor sea el costo del
                        imprevisto más es la cantidad que se tendrá que pagar.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 320px;">
                    <img src="assets/images/glossary/maximo-bitalicio.png" alt="" >
                    <h3 class="subTitle">Máximo Vitalicio:</h3>
                    <p class="ph">Es la cantidad máxima de reembolso a la que tendrá derecho una persona durante su vida.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"  style="margin: 0; min-height: 320px;">
                    <img src="assets/images/glossary/poliza.png" alt="" >
                    <h3>Póliza de Seguro:</h3>
                    <p class="ph"> <em>(s.)</em> Es un contrato entre dos partes (asegurado y
                        aseguradora), a través del cual se establecen los derechos
                        y obligaciones de ambas partes de acuerdo al tipo de
                        cobertura contratada.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray3"  style="margin: 0; min-height: 320px;">
                    <img src="assets/images/glossary/pago-directo.png" alt="" >
                    <h3 class="subTitle">Pago Directo:</h3>
                    <p class="ph"><em>(s.)</em> La aseguradora paga directamente al hospital, o al
                        prestador de servicios médicos, y usted solo paga lo que le
                        corresponda por concepto de deducible y coaseguro
                        directo en el proveedor.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-3">
            <div class="ui-g-12">
                <div class="cardGray"  style="margin: 0; min-height: 320px;">
                    <img src="assets/images/glossary/suma-asegurada.png" alt="" >
                    <h3 class="subTitle">Suma Asegurada:</h3>
                    <p class="ph"> <em>(s.)</em> Es el monto máximo de indemnización de la
                        aseguradora al asegurado dentro del período
                        de vigencia de la póliza.</p>
                </div>
            </div>
        </div>
    </div>
</div>